import React from 'react'
import { useTrans } from '@next-nx/hooks'
import { VeicoloLandingType } from '@next-nx/utils/types'
import { VeicoloLandingCard } from '@next-nx/shared-ui/molecules'
import styles from './LandingOfferteSection.module.sass'

interface Props {
  offertaInEvidenza?: VeicoloLandingType
  offerte?: VeicoloLandingType[]
  className?: string
}

const LandingOfferteSection = (props: Props) => {

  const { 
    offertaInEvidenza = null,
    offerte = [],
    className = '',
  } = props

  const t = useTrans()

  return offerte.length > 0 || offertaInEvidenza ? (
    <div className={`${styles.root} ${className}`}>
      <p className={styles.title}>{t("Scopri le offerte a te riservate")}</p>
      {offertaInEvidenza && (
      <div className={styles.mainOffer}>
        <VeicoloLandingCard veicolo={offertaInEvidenza} showIe isClickable isCtaClickable variant="highlight" />
      </div>
      )}
      {offerte.length > 0 && (
        <div className={styles.offers}>
          <p className={styles.offersTitle}>{t("In evidenza")}</p>
          <div className={`${styles.list} ${styles[`list--n${offerte.length === 2 ? '' : offerte.length % 3 === 0 ? '3' : '4' }`]}`}>
            {offerte.map(offerta => (
              <div className={styles.item} key={offerta.pk}>
                <VeicoloLandingCard veicolo={offerta} showIe isClickable isCtaClickable />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  ) : null
}

export default LandingOfferteSection
